import { walletconnect, walletlink } from "../walletUtils";
import { AbstractConnector } from "@web3-react/abstract-connector";
import { message } from "antd";
import { IAllowedNetwork } from "./types";
import { CHAINS } from "./Chain";

export async function requestSwitchNetwork(
  chainId: number,
  connector?: AbstractConnector
) {
  const chainIdHex = `0x${chainId.toString(16)}` as IAllowedNetwork;
  // if not using meta mask => Reject the connection
  if (connector == walletconnect || connector == walletlink) {
    message.error(
      `Wrong Network - Please connect to ${CHAINS[chainId].chainName} to claim!`
    );
    return false;
  }

  const provider = (window as any)?.ethereum;

  if (provider) {
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chainIdHex }],
      });
      message.success("Network Changed!");
    } catch (switchError: any) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainName: CHAINS[chainId].chainName,
                chainId: chainIdHex,
                rpcUrls: CHAINS[chainId].rpcUrls,
                nativeCurrency: CHAINS[chainId].nativeCurrency,
              },
            ],
          });
        } catch (addError) {
          console.log({ addError });
        }
      }
    }
  }
}
